import { Box, Grid, Link, Typography } from '@mui/material';
import React, { useRef } from 'react';
import {
  CortisolResultsCard,
  BloodResultsCard,
  DNAResultsCard,
  Journey,
  ManualTesting,
  Omega,
  OrderTracking,
  RootineFooter,
  RootineInvite,
  Welcome,
} from '../components';
import { NutrientsSection } from '../components/PostQuiz/NutrientsSection';

// flip boolean value to display test kit registration link
const DISPLAY_TEST_KIT_REGISTRATION = false;

export const Dashboard = (): JSX.Element => {
  const orderTrackingRef = useRef(null);
  const formulaTableRef = useRef(null);

  const scrollToOrderTracking = () => {
    // @ts-ignore
    orderTrackingRef.current?.scrollIntoView({
      behavior: 'smooth',
      block: 'start',
    });
  };
  const scrollToFormulaTable = () => {
    // @ts-ignore
    formulaTableRef.current?.scrollIntoView({
      behavior: 'smooth',
      block: 'start',
    });
  };

  return (
    <>
      <Grid
        container
        alignItems="center"
        justifyContent="center"
        spacing={4}
        rowSpacing={2}
        sx={{
          px: { xs: 2, md: 10 },
          marginTop: { xs: 6, md: 10 },
        }}
      >
        {/* <ManualTesting /> */}
        <Grid item xs={12}>
          <Welcome scrollToFormulaTable={scrollToFormulaTable} />
        </Grid>
        {DISPLAY_TEST_KIT_REGISTRATION && (
          <Grid item xs={12}>
            <Typography variant="medium" fontSize={20}>
              Have a test kit?{' '}
              <Link href="/dashboard/register-kit">Register it here</Link>
            </Typography>
          </Grid>
        )}
        <Grid item xs={12}>
          <Journey />
        </Grid>
        {/* We're commenting this out because we're phasing out the referral
         program, at least for now. we may bring it back later.

        <Grid item xs={12} md={6}>
          <RootineInvite />
        </Grid> */}
        <Grid item xs={12} ref={orderTrackingRef}>
          {/* <OrderTracking /> */}
        </Grid>
        <Grid item xs={12} sx={{ mt: { xs: 1, md: 3 }, mb: 1 }}>
          <Typography variant="medium" fontSize={{ xs: 24, md: 36 }}>
            Reports
          </Typography>
        </Grid>
        <Grid item xs={12} md={6} lg={4} xl={3}>
          <DNAResultsCard scrollToOrderTracking={scrollToOrderTracking} />
        </Grid>
        <Grid item xs={12} md={6} lg={4} xl={3}>
          <BloodResultsCard
            testType="vitamin"
            scrollToOrderTracking={scrollToOrderTracking}
          />
        </Grid>
        <Grid item xs={12} md={6} lg={4} xl={3}>
          <BloodResultsCard
            testType="mineral"
            scrollToOrderTracking={scrollToOrderTracking}
          />
        </Grid>
        <Grid item xs={12} md={6} lg={4} xl={3}>
          <CortisolResultsCard scrollToOrderTracking={scrollToOrderTracking} />
        </Grid>
        <Grid item xs={12} ref={formulaTableRef}>
          <Box sx={{ mt: { xs: 3, md: 5 }, mb: { xs: 1, md: 2 } }}>
            <Typography variant="medium" fontSize={{ xs: 24, md: 36 }}>
              Your Precision Formula
            </Typography>
          </Box>
          <NutrientsSection isTableOnly />
          <Box sx={{ mt: { xs: 6, md: 7 }, mb: 3 }} />
          {/*  <Typography variant="medium" fontSize={{ xs: 24, md: 36 }}>
              Add Omega
            </Typography>
          </Box>
          <Omega /> */}
          <RootineFooter />
        </Grid>
      </Grid>
    </>
  );
};
